import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { PaymentInfoDownloadRequest, PaymentInfoRequest } from "../shared/models/paymentInfo.model";
import { FileName } from "../constants/common.constants";

export const urlManagementService = createApi({
  reducerPath: "urlManagementService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getPaymentInfo: builder.mutation<any, PaymentInfoRequest>({
      query: ({ nameMerchant, skip_log, ...others }) => ({
        url: `/payment-info`,
        method: "POST",
        body: others,
        headers: !skip_log
          ? {
              PageName: "Pay By Link History",
            }
          : {},
      }),
    }),
    getHostedPaymentInfo: builder.mutation<any, PaymentInfoRequest>({
      query: ({ nameMerchant, skip_log, ...others }) => ({
        url: `/payment-info`,
        method: "POST",
        body: others,
        headers: !skip_log
          ? {
              PageName: "Hosted Payment Page History",
            }
          : {},
      }),
    }),
    getRelateTransaction: builder.query<any, any>({
      query: ({ alias, pageName }) => ({
        url: `/payment-info/${alias}/transaction-relation`,
        method: "GET",
        headers:
        {
          PageName: pageName ?? "Pay By Link History",
        },
      }),
    }),
    downloadPaymentInfo: builder.query<any, PaymentInfoDownloadRequest>({
      query: ({ nameMerchant, skip_log, ...others }) => ({
        url: `/report/transactions/download`,
        method: "GET",
        params: others,
        headers: !skip_log
          ? {
            PageName: "Transaction",
          }
          : {},
      }),
    }),
  }),
});

export const {
  // useLazyGetPaymentInfoQuery,
  useGetPaymentInfoMutation,
  useGetHostedPaymentInfoMutation,
  useLazyDownloadPaymentInfoQuery,
  useLazyGetRelateTransactionQuery,
} = urlManagementService;
